import React, { Component } from 'react'
import '../styles/OtherProjectListME.css'
import InputSearchWidget from '../widgets/InputSearchWidget'
import ActivityIndicator from '../widgets/ActivityIndicator'
import APIOtherProjectRequest from '../api/APIOtherProjectRequest'

class OtherProjectListME extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			listItems: [],
			searchLabel: "0 PROJECT",
			projects: []
		}
		this.viewDetails = this.viewDetails.bind(this)
		this.getAllOtherProject = this.getAllOtherProject.bind(this)
	}

	componentWillMount() {
		this.getAllOtherProject()
	}

	getAllOtherProject() {
		this.setState({showActivityIndicator: true})
		const apiReq = APIOtherProjectRequest.getAllOtherProjects(this.state.accessToken);
		apiReq.then((response) => {
			console.log(response)
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return;
			}
			const projects = []
			const listItems = []
			for(const v of response.results.rows) {
				projects.push({project_id: v.project_id, project_name: v.project_name})
			}
			for(const v of projects) {
				listItems.push(<ListItem data={v} viewDetails={this.viewDetails} />)
			}
			this.setState({
				listItems: listItems,
				projects: projects,
				searchLabel: projects.length + " PROJECT(S)",
				showActivityIndicator: false
			})

		})
	}
	viewDetails(id, name) {
		this.props.viewDetails("view-details", id, name)
	}

	render() {
		const view = <div id="project-list-me">
			<div className="plm-top">
				<InputSearchWidget placeholder="SEARCH" cStyle={{'width': '285px'}}
					onSearchClick={(value) => {
						if(this.state.projects == null) {
							return
						}
						const sr = searchString(value, this.state.projects)
						if(sr == null) {
							return
						}
						const listItems = []
						for(const v of sr) {
							listItems.push(<ListItem data={v} viewDetails={this.viewDetails} />)
						}
						this.setState({
							searchLabel:  sr.length + "PROJECTS",
							listItems: listItems
						})
					}}
					onEnterPress={(value) => {
						if(this.state.projects == null) {
							return
						}
						const sr = searchString(value, this.state.projects)
						if(sr == null) {
							return
						}
						const listItems = []
						for(const v of sr) {
							listItems.push(<ListItem data={v} viewDetails={this.viewDetails} />)
						}
						this.setState({
							searchLabel:  sr.length + " PROJECTS",
							listItems: listItems
						})
					}} />
				<div className="plm-label"><div>{this.state.searchLabel}</div></div>
			</div>
			<div className="plm-items">{this.state.listItems}</div>
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
		</div>
		return(view)
	}
}

function ListItem(props) {
	return(<div className="plm-list-item">
			<table className="plm-table-data">
				<col style={{width: '100%'}} />
				<tr>
					<td>{props.data.project_name}</td>
					<div className="plm-grid-btn"><button className="btn-view-details" onClick={(e) => {
						console.log(props.data)
							props.viewDetails(props.data.project_id, props.data.project_name)
						}}>VIEW DETAILS</button>
					</div>
				</tr>
			</table>
	</div>)
}

const searchString = (str, data) => {
	if(data.length < 1) {
		return;
	}
	if(str == null) {
		str = ""
	}
	const list = [];
	for(const v of data) {
		const name = v.project_name;
		if(name.toLowerCase().includes(str.toLowerCase())) {
			list.push(v);
		}
	}
	return(list);
}

export default OtherProjectListME
